export const getStructuralDescendentIds = (graph = {}, stepId) => {
  const descendents = new Set();
  const root = graph?.[stepId];

  const visit = (id) => {
    if (!id || id === stepId || descendents.has(id) || !graph?.[id]) {
      return;
    }

    descendents.add(id);

    const node = graph[id];
    visit(node?.child);
    for (const branchId of node?.branches || []) {
      visit(branchId);
    }
    visit(node?.exit);
  };

  visit(root?.child);
  for (const branchId of root?.branches || []) {
    visit(branchId);
  }

  return descendents;
};
